/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ExperienceLevel = {
    Entry: 'ENTRY',
    Intermediate: 'INTERMEDIATE',
    Expert: 'EXPERT',
    ExpertPlus: 'EXPERT_PLUS'
} as const;
export type ExperienceLevel = typeof ExperienceLevel[keyof typeof ExperienceLevel];


export function instanceOfExperienceLevel(value: any): boolean {
    for (const key in ExperienceLevel) {
        if (Object.prototype.hasOwnProperty.call(ExperienceLevel, key)) {
            // @ts-ignore
            if (ExperienceLevel[key] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ExperienceLevelFromJSON(json: any): ExperienceLevel {
    return ExperienceLevelFromJSONTyped(json, false);
}

export function ExperienceLevelFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExperienceLevel {
    return json as ExperienceLevel;
}

export function ExperienceLevelToJSON(value?: ExperienceLevel | null): any {
    return value as any;
}

